type Props = {
  active: string;
  lang: "id" | "en";
  setActive: (v: string) => void;
};

export default function AdminCompanyProfileTabs({ active, setActive, lang }: Props) {
  const tabs = [
    { key: "Profile", label: { id: "Profil", en: "Profile" } },
    {
      key: "Company Verifications",
      label: { id: "Verifikasi Perusahaan", en: "Company Verifications" },
    },
  ];

  return (
    <div className="flex gap-6 border-b mt-6">
      {tabs.map((tab) => (
        <button
          key={tab.key}
          onClick={() => setActive(tab.key)}
          className={`pb-3 font-semibold transition ${
            active === tab.key
              ? "text-primary border-b-2 border-primary"
              : "text-white hover:text-black"
          }`}
        >
          {tab.label[lang]}
        </button>
      ))}
    </div>
  );
}
